import { render, staticRenderFns } from "./messagelistpager.vue?vue&type=template&id=8c847786&"
import script from "./messagelistpager.vue?vue&type=script&lang=ts&"
export * from "./messagelistpager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports